export class PublicTabs {
    constructor() {

    }
    run() {
        this.eventListeners();
        this.disableTabHeaderNewButton();
    }

    eventListeners() {
        window.addEventListener('click', (e) => {
            const header = e.target.closest('.tab-header:not(.tab-header-new)');
            if (header) {
                e.preventDefault();
                let tab_id = header.dataset.tab;
                let container = header.closest('.tabs-box');
                if (!container){
                    return;
                }
                // if(container.classList.contains('__first')){
                //     container.classList.remove('__first');
                // }
                if(container.querySelector('.tab-header.active')){
                    container.querySelector('.tab-header.active').classList.remove('active');
                }
                header.classList.add('active');
                if(container.querySelector('.tab-item.active')){
                    container.querySelector('.tab-item.active').classList.remove('active');
                }
                let active_tab = container.querySelector(`.tab-item[data-tab="${tab_id}"]`);
                active_tab.classList.add('active');
                // get height of active tab and set it to container
                // let active_tab_height = active_tab.offsetHeight;
                // container.querySelector('.tabs-list').style.height = `${active_tab_height}px`;
            }
        });

        document.addEventListener('existingArticleRendered', () => {
            this.disableTabHeaderNewButton();
        });
    }
    scrollTabsHeader() {
        //console.log('scrollTabsHeader')
        const tabsHeaderWrapper = document.querySelector('.tabs-header-wrapper');
        if(tabsHeaderWrapper){
            //console.log('tabsHeaderWrapper')
            tabsHeaderWrapper.addEventListener('wheel', function(event) {
                const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
                //console.log('Horizontal scroll position:', scrollLeft);
            });
        }
    }

    disableTabHeaderNewButton() {
        const tabBoxes = document.querySelectorAll('.tabs-box');

        if (tabBoxes) {
            tabBoxes.forEach(box => {
                const items = box.querySelectorAll('.tab-item');
                const tabHeaderNewBtn = box.querySelector('.tab-header-new');
                const itemsCount = items.length;

                if (itemsCount === 4 && tabHeaderNewBtn) {
                    tabHeaderNewBtn.classList.add('disabled');
                }
            });
        }
    }
}
